import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import Loading from 'components/ui/Loader';
import { ChevronLeftIcon } from "components/icons/Icons";
import { useBorrowerProfiling } from "../../hooks/useBorrowerProfiling";
import GenericQuestion from "../generic/GenericQuestion";
import { FC, useMemo } from "react";

export const BorrowerProjectQuestion: FC<{ upsertBorrowerProject: (projectType: string, insuranceProject: string, projectStartDate: string) => void }> = ({ upsertBorrowerProject }) => {
  const { t } = useDynamicTranslation([NsKey.Common]);

  const {
    currentQuestionGroup,
    isFirstStep,
    answers,
    isLoading,
    questionsToShow,
    handleQuestionAnswer,
    handlePrevious,
  } = useBorrowerProfiling(upsertBorrowerProject);

  if (!currentQuestionGroup) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="text-center">
          <div className="text-lg text-gray-600">Chargement...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 p-8">
      <div className="relative">
        {
          !isFirstStep &&
          <button className="flex gap-4 absolute" onClick={handlePrevious}>
            <ChevronLeftIcon />
            {t("COMMON.BACK")}
          </button>
        }
        {questionsToShow.map((question, index) => (
          <div key={question.key + index}>
            <GenericQuestion
              question={question}
              currentAnswers={answers[question.key] || []}
              onAnswer={handleQuestionAnswer}
            />
          </div>
        ))}
      </div>
      {isLoading && <Loading loading={isLoading} isFullPage />}
    </div>
  );
};
